import React, { useState } from "react";
// import { CognitoUser } from "amazon-cognito-identity-js";
// import Pool from "../UserPool";
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
  NavBtnLink
} from './ForgotPasswordElements';

const ForgotPassword = () => {
  const [stage, setStage] = useState(1); // 1 = email stage, 2 = code stage
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  async function handleResetPassword() {
    try {
      const output = await resetPassword({ username: email });
      handleResetPasswordNextSteps(output);
      setStage(2);
    } catch (error) {
      console.log(error);
    }
  }

  function handleResetPasswordNextSteps(output) {
    const { nextStep } = output;
    switch (nextStep.resetPasswordStep) {
      case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        console.log(
          `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
        );
        // Collect the confirmation code from the user and pass to confirmResetPassword.
        break;
      case 'DONE':
        console.log('Successfully reset password.');
        break;
    }
  }

  async function handleConfirmResetPassword() {
    if (password !== confirmPassword) {
      console.error("Passwords are not the same");
      return;
    }

    try {
      await confirmResetPassword({ username: email, confirmationCode: code, newPassword: password });
      setStage(3);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Container >
      <FormWrap>
        {stage === 1 && (
          <FormContent>
            <Form action='#'>
              <FormH1>Enter your email address</FormH1>
              <FormLabel htmlFor='for'>Email</FormLabel>
              <FormInput type='email' value={email} onChange={event => setEmail(event.target.value)} required />
              <FormButton type='submit' onClick={handleResetPassword}>Send Verification Code</FormButton>
            </Form>
          </FormContent>
        )
        }
        {
          stage === 2 && (
            <FormContent>
              <Form action='#'>
                <FormLabel htmlFor='for'>Verification Code</FormLabel>
                <FormInput type='password' value={code} onChange={event => setCode(event.target.value)} required />
                <FormLabel htmlFor='for'>Password</FormLabel>
                <FormInput type='password' value={password} onChange={event => setPassword(event.target.value)} required />
                <FormLabel htmlFor='for'>Confirm Password</FormLabel>
                <FormInput type='password' value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} required />
                <FormButton type='submit' onClick={handleConfirmResetPassword}>Reset Password</FormButton>
              </Form>
            </FormContent>
          )
        }
        {
          stage === 3 && (
            <FormContent>
              <Form action='#'>
                <Text>Successfully Reset Password</Text>
                <NavBtnLink to='/signin'>Return To Sign In?</NavBtnLink>
              </Form>
            </FormContent>
          )
        }
      </FormWrap>
    </Container >
  );
};

export default ForgotPassword;